import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission, RepairWorkDto, RepairWorkReferenceDto } from "@/core/api/generated/v1";

import { RepairMaterialInlineProps } from "../RepairMaterial/RepairMaterialInline";
import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import RepairWorkInline from "./RepairWorkInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: RepairWorkDto | RepairWorkReferenceDto | null | undefined;
  entityId?: string | null;
  inlineProps?: Partial<RepairMaterialInlineProps>;
}

export default function RepairWorkLink({ entity, entityId, inlineProps, ...otherProps }: Props) {
  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.RepairCatalogRead]}
      to={ROUTE_PATH.REPAIR_WORK_VIEW(entity?.id || entityId || "")}
      content={<RepairWorkInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
